import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { substances, reactions, tgitems } from '@Constants';

import AvailableRelativeContextButton from './AvailableRelativeContextButton';


function CitationsRelativeContextsList (props) {
  const {
    availableRelativeContext,
  } = props;

  const substancesItem = availableRelativeContext.get(substances);
  const reactionsItem = availableRelativeContext.get(reactions);
  const tgitemsItem = availableRelativeContext.get(tgitems);

  return (
    <>
      {
        substancesItem && (
          <>
            <span className="hide-below-laptop">with&nbsp;</span>
            <AvailableRelativeContextButton {...props} item={substancesItem}/>
          </>
        )
      }
      {
        reactionsItem && (
          <>
            ,&nbsp;
            <AvailableRelativeContextButton {...props} item={reactionsItem}/>
          </>
        )
      }
      {
        tgitemsItem && (
          <>
            ,&nbsp;
            <AvailableRelativeContextButton {...props} item={tgitemsItem}/>
          </>
        )
      }
    </>
  );
}

CitationsRelativeContextsList.propTypes = {
  availableRelativeContext: PropTypes.instanceOf(Map),
};

export default CitationsRelativeContextsList;
